import script from "./ArticlePagination.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArticlePagination.vue?vue&type=script&setup=true&lang=ts"

import "./ArticlePagination.vue?vue&type=style&index=0&id=4abe7825&lang=scss"

const __exports__ = script;

export default __exports__